import React from 'react';
import { SelectInput } from 'react-admin';

const DiscountTypeInput = (props) => {
	return <SelectInput source="type" choices={[ { id: 0, name: 'Percentage' }, { id: 1, name: 'Amount' } ]} />;
};

export default DiscountTypeInput;
